import styled from 'styled-components';
import { rgba } from 'polished';

import {
  ColumnSettings,
  MarketValuesView,
} from '#/features/options/option-tables-context';
import { c0B0B20, c56EA99, cEA135E, cFFFFFF } from '#/colors';

import { BaseCell } from './atoms';

interface Props {
  settings: ColumnSettings;
  view: MarketValuesView;
}

export default function Cell({ settings, view }: Props) {
  if (!settings.visible) return null;

  switch (settings.key) {
    case 'bestAskPriceQuoteCurrency':
      return (
        <Container>
          <Ask>{view[settings.key]}</Ask>
          <div>-</div> {/* WIP: `view.bestAskIV` to be introduced later  */}
        </Container>
      );
    case 'bestBidPriceQuoteCurrency':
      return (
        <Container>
          <Bid>{view[settings.key]}</Bid>
          <div>-</div> {/* WIP: `view.bestBidIV` to be introduced later  */}
        </Container>
      );
    default:
      return <Container>{view[settings.key]}</Container>;
  }
}

const Container = styled(BaseCell)`
  font-size: 12px;
  font-weight: 500;
  color: ${rgba(cFFFFFF, 0.7)};
  font-family: 'Roboto Mono', monospace;
`;

const Ask = styled.div`
  color: ${cEA135E};
`;

const Bid = styled.div`
  color: ${c56EA99};
`;

export const CellStrike = styled(Container)`
  color: ${cFFFFFF};
  justify-self: center;
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;
  background-color: ${c0B0B20};
`;
